import type { NavigationPillar } from '@/lib/navigation-pillars';
import type { DataLayerUserInfo } from './data-layer';

export type BrowsingPreference = NonNullable<DataLayerUserInfo['browsing_preference']>;

const BROWSING_PREFERENCE_BY_PILLAR: Record<NavigationPillar, BrowsingPreference> = {
    onlineShop: 'product',
    courses: 'class',
    events: 'event',
    restaurants: 'restaurant',
};

/** Maps the persisted primary shopping pillar to GA4 `browsing_preference`. */
export function resolveBrowsingPreference(pillar: NavigationPillar | null | undefined): BrowsingPreference | undefined {
    return pillar ? BROWSING_PREFERENCE_BY_PILLAR[pillar] : undefined;
}
